/*=========================================================================================
  File Name: state.js
  Description: POS State
  ----------------------------------------------------------------------------------------
  Item Name: POS Module
  Author: Tan Tran
==========================================================================================*/

export default {
    categories : [],
    products : [],
    taxes : [],
    orders : [],
    cart : [],
    currentWaitingTime : 20,
    orderManagerState : {
      capacity : 1,
      currentWaitingTime : 5,
      minWaitingTime : 5,
      maxWaitingTime : 10,
      cannotOrderNow : false,
      increaseTimeStep : 2,
      pendingOrdersIncreaseStep : 2,
      initTimeOfOrder : 2,
      offTime : null,
      isEnabled : false
    },
    resetState : false
  } 